<template>
  <div id="HeaderTop">
    <div class="head_wrap in_box">
      <div class="top">
        <!-- <div class="w1200">
          <ul class="flexDiv">
            <li><a href="javascript:;">江苏省数控高职实训基地建设点</a></li>
            <li>
              <a href="javascript:;"
                >江苏省高等教育汽车类专业人才培养模式创新实验基地</a
              >
            </li>
          </ul>
          <ul class="flexDiv">
            <li><a href="javascript:;" target="_blank">董事长信箱</a></li>
            <li><a href="javascript:;" target="_blank">院长信箱</a></li>
            <li><a href="javascript:;" target="_blank">OA办公</a></li>
            <li><a href="javascript:;" target="_blank">金肯内网</a></li>
            <li>
              <a href="http://222.193.143.194/default.aspx" target="_blank"
                >教务系统</a
              >
            </li>
            <li>
              <a href="http://xxgk.jku.edu.cn/" target="_blank">信息公开</a>
            </li>
          </ul>
        </div> -->
      </div>
      <div class="clearfix">
        <div class="Top_logo">
          <a id="LOGO" href="./index.html"
            ><img :src="LogoList.Logo" alt=""
          /></a>
          <div class="logo_text">
            <p>质量与教科研处</p>
            <span>国标代码 13100</span>
          </div>
        </div>
        <div class="top-right">
          <div class="fr search_box in_box">
            <input
              class="fl search"
              id="search"
              type="text"
              placeholder="请输入关键词"
              autocomplete="off"
              v-model="SearchStr"
              @keyup.enter="Search"
            />
            <a @click.stop="Search">
              <div class="btn_search fr" id="searchbtn"><i></i></div>
            </a>
          </div>
        </div>
      </div>
      <div class="Menu">
        <ul id="Menu">
          <li v-for="item in menuListOne" :key="item.ID">
            <a
              v-if="item.Url.indexOf('http') !== -1"
              :href="item.Url"
              target="_blank"
              >{{ item.Name }}</a
            >
            <router-link
              v-else
              :to="item.Children.length == 0 ? item.Url : item.Children[0].Url"
              :key="CId"
              :class="[item.On ? 'on' : '']"
              ><i></i> {{ item.Name }}</router-link
            >
            <dl v-if="item.Children.length > 0">
              <dd v-for="item2 in item.Children" :key="item2.ID">
                <router-link
                  v-if="item2.Url.indexOf('http') == -1"
                  :to="item2.Url"
                  :key="item2.ID"
                  >{{ item2.Name }}</router-link
                >
                <a v-else :href="item2.Url" target="_blank">{{ item2.Name }}</a>
              </dd>
            </dl>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HeaderTop",
  data() {
    return {
      LogoList: [],
      menuList: [],
      menuListOne: [],
      CId: this.$route.query.CId,
      SearchStr: null
    };
  },
  methods: {
    Search() {
      if (!this.SearchStr) {
        alert("请输入查询关键词");
      } else {
        this.$router.push("./search.html?selText=" + this.SearchStr);
      }
    }
  },
  created() {
    this.LogoList = this.Base.GetOrganInfoByOid(50);
    this.menuList = this.Base.GetNavColumnsByDid();
    this.menuListOne = this.menuList.filter(ele => ele.FID == 0);
    this.menuListOne.forEach(r => {
      r.Children = this.menuList.filter(ele => ele.FID == r.ID);
    });
    // this.menuListOne.push({
    //   Name: "学院首页",
    //   Url: "http://www.jku.edu.cn/",
    //   On: true,
    //   Children: [],
    // });
    this.menuListOne.unshift({
      Name: "首页",
      Url: "./index.html",
      On: true,
      Children: []
    });
    // console.log(this.menuListOne);
  }
};
</script>

<style lang="less" scoped>
.head_wrap {
  background-color: #f5f5f5;

  .top {
    width: 100%;
    height: 20px;

    // background-color: #eaeeff;
    div {
      height: 20px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;

      ul {
        margin: 0;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;

        &:first-child {
          width: 510px;

          li::after {
            content: "";
            width: 1px;
            height: 14px;
            background: #646464;
            position: absolute;
            right: -8px;
            bottom: 3px;
            z-index: 11;
          }
        }

        &:last-child {
          width: 452px;

          li::after {
            content: "";
            width: 1px;
            height: 14px;
            background: #0467ad;
            position: absolute;
            right: -13px;
            bottom: 3px;
            z-index: 11;
          }
        }

        li {
          &:last-child::after {
            content: none;
          }

          position: relative;
          margin: 0;

          a {
            display: block;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 20px;
            letter-spacing: 1px;
            color: #646464;
          }
        }
      }
    }
  }

  .clearfix {
    width: 1200px;
    margin: 0 auto;
    height: 130px;
    padding-top: 28px;
    padding-bottom: 29px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    justify-content: space-between;

    .Top_logo {
      width: 560px;
      margin: 0;
      height: 73px;
      position: relative;

      a {
        display: block;
        height: 73px;

        img {
          display: block;
          object-fit: contain;
        }
      }

      .logo_text {
        float: right;
        margin-top: 13px;
        padding-left: 13px;
        height: 50px;
        border-left: solid 1px #0069b7;
        position: absolute;
        right: 0;
        top: 0;

        p {
          font-size: 20px;
          font-weight: bold;
          font-stretch: normal;
          line-height: 30px;
          letter-spacing: 1px;
          color: #0069b7;
        }

        span {
          display: block;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 20px;
          letter-spacing: 1px;
          color: #0069b7;
        }
      }
    }

    .top-right {
      margin: 0;

      .in_box {
        width: 410px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;

        input {
          width: 310px;
          height: 37px;
          background-color: #ffffff;
          border-radius: 5px;
          padding: 0 20px;
          color: #646464;
          box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.38);
        }

        a {
          margin-left: 15px;
          width: 40px;
          height: 40px;
          background: url(../assets/img/search.png) center no-repeat;
        }
      }
    }
  }

  #Menu {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    height: 70px;
    background-color: #ffffff;
    align-content: center;
    position: relative;
    z-index: 99999;

    &::after {
      content: "";
      width: 1160px;
      height: 26px;
      background: url(../assets/img/ico-nav.png) no-repeat center;
      position: absolute;
      left: 14px;
      bottom: -26px;
    }

    li {
      text-align: center;
      flex: 1;
      display: inline-block;
      position: relative;
      vertical-align: top;

      &:last-child {
        margin-right: 0px;

        &::after {
          content: none;
        }
      }

      &::after {
        content: "";
        width: 1px;
        height: 38px;
        background-color: rgba(0, 0, 0, 0.2);
        position: absolute;
        right: 0;
        top: 17px;
      }

      &:hover {
        dl {
          max-height: 1000px;
        }
      }

      a {
        display: block;
        font-size: 16px;
        font-family: "Microsoft YaHei";
        color: rgb(0, 0, 0);
        line-height: 70px;
        text-align: center;

        &:hover {
          color: #0376be;

          &::after {
            content: "";
            width: 25px;
            height: 2px;
            background-color: #0376be;
            position: absolute;
            bottom: 18px;
            left: 40%;
          }
        }
      }

      .on,
      .router-link-exact-active {
        color: #0376be;

        &::after {
          content: "";
          width: 25px;
          height: 2px;
          background-color: #0376be;
          position: absolute;
          bottom: 18px;
          left: 40%;
        }
      }

      dl {
        max-height: 0;
        width: 100%;
        position: absolute;
        z-index: 999999;
        overflow: hidden;
        -webkit-transition: max-height 0.3s;
        transition: max-height 0.3s;

        dd {
          width: 100%;
          height: 40px;
          margin-top: 1px;
          line-height: 39px;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.9);

          &:hover {
            a {
              color: #0376be;

              &::after {
                content: none;
              }
            }
          }

          a {
            color: #333333;
            line-height: 39px;
            font-size: 16px;
          }

          .on,
          .router-link-exact-active {
            color: #0376be;

            &::after {
              content: none;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderTop.vue